<span>{{ 'submitProposal.selectedText' | translate }}</span>

@for (group of selectedCourseList(); track group.title) {
  <pa-add-course-list-header [title]="group.title" [subTitle]="group.subTitle" />

  @for (courseData of group.courseData; track courseData.uniqueId) {
    <pa-course-item [courseData]="courseData" showCategory hideShowInfo hideTimeslots />
  }
}
